<template>
  <div :class="['menu-cover', openMenu?'open':'']">
	  <div id="coverBg" ref="coverBg">

	  </div>
	  <div class="menu">
		  <div>
	        <div class="logo">
	          <a href="/"><img src="@/assets/menubar/img-todomath-logo@2x.png"/></a>
	        </div>

	      </div>
	      <div>
	        <div>
	  		  <input  type="checkbox" id="mainMenuCtrl" v-model="openMenu"/>
	          <label for="mainMenuCtrl">
	  			<!-- <img class="menu-icon" src="@/assets/menubar/icon-menu-m.svg"/> -->
	  		</label>
	  		<div id="menus">
	  			<ul>
	  				<li>
	  					<router-link to="/features"><span>{{l10n.All_Head_Tapbutton1}}</span></router-link>
	  				</li>
	  				<li>
	  					<router-link to="/curriculum"><span>{{l10n.All_Head_Tapbutton2}}</span></router-link>
	  				</li>
	  				<li v-if="lang=='en'">
	  					<router-link to="/educators"><span>{{l10n.All_Head_Tapbutton3}}</span></router-link>
	  				</li>
	  				<li>
	  					<router-link to="/help/faq"><span v-html="l10n.All_Footer_Menubutton_Buttonname5"></span></router-link>
	  				</li>
	  			</ul>
	  		</div>

	        </div>

	      </div>
	  </div>


  </div>
</template>

<script>
import L10N from '../../text/common/header.js'
export default {
  name: 'Header',
  watch:{
	  $route(to, from){
		  if(to.fullPath != from.fullPath){
			  this.openMenu=false;
		  }
	  }
  },
  data () {
	  var setL10n = L10N[this.$store.state.lang];
    return {
      lang:this.$store.state.lang,
	  l10n:setL10n,
	  openMenu:'',
    }
	},
	watch:{
		'openMenu'(to, from){
			document.getElementById('coverBg').style.height = document.body.offsetHeight+'px';
			// .height = document.body.offsetHeight

		}
	},
	methods: {
    onClick(to) {
      if (to == window.location.pathname) return
      this.$router.push(to + window.location.search)
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menu-cover{
	  position: absolute;

	width: 100%;
	left:0;

}
.menu-cover.open{
	background-color: #42c0ff;
}
#coverBg{
	position: absolute;
	left:0;
	top:100px;
	z-index: 200;
	height:100%;
	background-color: rgba(0,0,0,0.7);
	width: 100%;
	display: none;
}
.menu-cover.open #coverBg{

	display: block;
}

.menu{
  width:650px;
  margin: 0 auto;

  height:100px;

  left: 0;
  display: flex;
  justify-content: space-between;
  padding:0;
  z-index: 300;

}


.menu>div{
  display: flex;
  align-items: center;

}
.menu>div>div.logo{
  width: 78.4px;

}

.menu>div>div.logo img{
  width: 100%;
}

.menu>div>div:last-of-type{

}
.menu .menu-icon{
  width: 72px;
}
#mainMenuCtrl{
	display: none;
}
#mainMenuCtrl~label{
	display: inline-block;
	z-index: 700;
}
#mainMenuCtrl~label::after{
	content:url("../../assets/menubar/icon-menu-m.svg");

}
/* #mainMenuCtrl:checked~label::after{
	content:'X';
	font-size: 50px;

} */

#menus{
	position: absolute;
	width: 100%;
	left:0;
	display: none;
	background-color: #fff;
	font-size: 48px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -1px;
  color: #41403e;

	 top:100px;
	 z-index: 600;
}
#menus ul{
	list-style-type: none;
	/* transition: all 0.5s linear; */
 	z-index: 1000;
	margin:0;
	padding:0;
	position: relative;
	background-color: #42c0ff;
	overflow-y: auto;
	padding:50px 0;
	border-top: solid 2px rgba(255,255,255,0.2);

}
#menus ul li{
	min-height: 50px;
	width: 100%;
}
#menus ul li a{
	width: 100%;
	height: 120px;
	display: flex;
	align-items: center;


}
#menus ul li a span{
  display: inline-block;
  width: 720px;
  margin: 0 auto;
  padding:0px 35px;
}
#menus ul li ul{
	padding-left: 28px;
	list-style-type: none;
}
#mainMenuCtrl:checked~#menus{
	display: block;
}


#menus:checked ~ ul{

	opacity:1;


}
label[for]:hover{
	cursor: pointer;
}
.router-link-exact-active, .router-link-active{
	font-weight: bold;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/menubar/MobileLayout.vue